import { RouteToolError, type RouteToolsRepository } from '../../application/RouteToolsRepository'

/**
 * Démonstration : aucun service d'optimisation n'existe hors Supabase. L'outil y reste « À configurer » et aucun
 * calcul n'est simulé (un résultat inventé passerait pour un vrai).
 */
export function createFixtureRouteTools(): RouteToolsRepository {
  const unavailable = () => Promise.reject(new RouteToolError('PROVIDER_NOT_CONFIGURED'))
  return {
    getOptimizationStatus: () => Promise.resolve({ configured: false }),
    optimize: unavailable,
    listRuns: () => Promise.resolve([]),
    getRun: unavailable,
    apply: unavailable,
    revert: unavailable,
    cancel: unavailable,
    // Démonstration : aucun tronçon de rue importé, l'outil reste « À configurer ».
    getStreetSegmentsStatus: () => Promise.resolve({ count: 0, sourceVersion: null, sourceDate: null }),
    getStreetSegmentsNear: () => Promise.resolve([]),
    createFlagRun: unavailable,
    completeFlagRun: unavailable,
    applyFlags: unavailable,
    revertFlags: unavailable,
    // Démonstration : aucun fournisseur IA ; l'outil reste « Non configurée », aucun résultat simulé.
    getAiSettings: () =>
      Promise.resolve({
        provider: 'GEMINI_API',
        model: null,
        modelVerifiedAt: null,
        concurrency: 3,
        maxAttempts: 3,
        maxTasksPerRun: 150,
        reviewMoveThresholdM: 25,
        priceInputPerMtok: null,
        priceOutputPerMtok: null,
        priceCheckedOn: null,
        imagerySource: null,
        pilotRoutes: [],
        updatedAt: null,
      }),
    saveAiSettings: unavailable,
    getAiProviderStatus: () => Promise.resolve({ keyConfigured: false }),
    verifyAiModel: unavailable,
    createAiFlagRun: unavailable,
    processAiFlagRun: unavailable,
    getAiFlagRun: unavailable,
    getActiveAiFlagRun: () => Promise.resolve(null),
    stopAiFlagRun: unavailable,
    resumeAiFlagRun: unavailable,
    setFlagDecision: unavailable,
  }
}
